import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { TemplatePreviewTemplate } from '../src/templatePreviewHelpers.tsx';

export const TemplatePreview: LoadableType<{
	spaceKey: string;
	templates: TemplatePreviewTemplate[];
	currentTemplateIndex?: number;
	numPreviewsToFetchAtOnce?: number;
	isScrollable?: boolean;
	marginBottom?: number;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplatePreview" */ '../src/TemplatePreview.tsx'))
			.TemplatePreview,
});
